import React from "react";
 import  { useState, useEffect } from 'react';
 import { DataGrid } from '@mui/x-data-grid';
 import { configData } from "../config";
 import { Link } from '@mui/material';
 import './classes/ManageEmails.css';
import SalespersonSidebar from "./SalespersonSidebar";
import { Helmet } from 'react-helmet';
import { useLocation,useNavigate,useSearchParams } from 'react-router-dom';
// import { useMockServer } from '@mui/x-data-grid-generator';
import { GridFilterInputValue } from '@mui/x-data-grid';
import Loading from './Loading';


const customStringOperators = [
  {
    label: 'contains',
    value: 'contains',
    getApplyFilterFn: (filterItem) => {
      if (!filterItem.value) return null;
      return ({ value }) =>
        value?.toString().toLowerCase().includes(filterItem.value.toLowerCase());
    },
    InputComponent: GridFilterInputValue,
  },
  {
    label: 'starts with',
    value: 'startsWith',
    getApplyFilterFn: (filterItem) => {
      if (!filterItem.value) return null;
      return ({ value }) =>
        value?.toString().toLowerCase().startsWith(filterItem.value.toLowerCase());
    },
    InputComponent: GridFilterInputValue,
  },
  {
    label: 'ends with',
    value: 'endsWith',
    getApplyFilterFn: (filterItem) => {
      if (!filterItem.value) return null;
      return ({ value }) =>
        value?.toString().toLowerCase().endsWith(filterItem.value.toLowerCase());
    },
    InputComponent: GridFilterInputValue,
  },
];

const columns = [
  {
    field: 'subject',
    headerName: 'Title',
    cellClassName:'subject_column',headerClassName:'subject_header',
    filterOperators: customStringOperators,
     renderCell: (params) => (
    <Link href={params.row.view_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.subject}
      </Link>
  ),
    
  },
  {
    field: 'emailcode',
    headerName: 'EmailCode',
    cellClassName:'emailcode_column',headerClassName:'emailcode_header',
   
    filterOperators: customStringOperators,
  },
  {
    field: 'import_sendgrid_activity',
    headerName: 'EmailCode',
    cellClassName:'import_sendgrid_activity_column',headerClassName:'import_sendgrid_activity_header',
   
    filterOperators: customStringOperators,
  },
  {
    field: 'updated_at',
    headerName: 'Updated date',
    cellClassName:'updated_at_column',headerClassName:'updated_at_header',
    filterOperators: customStringOperators,
    
  },
  {
    field: 'edit_link',
    headerName: 'Edit Link',
    cellClassName:'edit_link_column',headerClassName:'edit_link_header',
    sortable: false,
    filterable: false, // not filterable
    renderCell: (params) => (
      <Link href={params.row.edit_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.linkText || 'edit'}
      </Link>
    ),
  },
];





const ManageEmails =() =>{

    const [formData, setformData] = useState({
      manage_emails_title:''
    });

    const [appliedFormData, setAppliedFormData] = useState({
      manage_emails_title:''
    });
  /* Pagination, filter config starts here */
const [rows, setRows] = React.useState([]);
  const [rowCount, setRowCount] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
  const [sortModel, setSortModel] = React.useState([]);
  const [filterModel, setFilterModel] = React.useState({ items: [] });
  const [isLoading, setIsLoading] = useState(true);
const app_url = configData.APP_URL;
const location  = useLocation();
 const successMessage = location.state?.message; // Access the message
 window.history.replaceState({}, '');

    const handleChange = (event) => {
        const { name, value } = event.target;
        setformData({ ...formData, [name]: value });
        
    };

  React.useEffect(() => {
    const fetchData = async () => {
      // Simulate API call to your server
      // In a real application, replace this with your actual fetch logic
       try {
      const response = await fetch(app_url+'emails/getemaillist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel,
          filterModel,
          formData:appliedFormData
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
     // console.log("Type of totalRowCount:", typeof data.data.totalRowCount);
    }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
  

    };

    fetchData();
  }, [paginationModel, sortModel, filterModel, appliedFormData]); // Re-fetch data when these change

// const rowHeight = 32;
// const pageSize = paginationModel.pageSize;
// const gridHeaderHeight = 56;
// const paginationHeight = 56;
// const totalHeight = (rowHeight * pageSize) + gridHeaderHeight + paginationHeight;



  /* Pagination, filter config ends here */
// useEffect(() => {
//   console.log("Current Page:", paginationModel.page);
//   console.log("Page Size:", paginationModel.pageSize);
// }, [paginationModel]);

    const handleSubmit = async (e) => {
      e.preventDefault();
      setPaginationModel({
        page: 0,
        pageSize: 50,
      });
      setAppliedFormData({...formData});
    }
 
    return(
      <>
               {isLoading ? (
                    <Loading />
                  ) : (
        <div id="main">
            <div className="left"></div>
            <>
                <div className="center left-center">
                    <div className="manage_emails-container">
                      <Helmet><title>Manage Emails</title></Helmet>
                        {successMessage && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                        </div>
                        )}
                      <form className="manage-emails-form">
                          <div className="form-item">
                              <label htmlFor="edit-title">Title</label>
                              <div>
                                  <input 
                                      type="text" 
                                      id="edit-title" 
                                      name="manage_emails_title" 
                                      size={30} 
                                      maxLength={128} 
                                      onChange={handleChange}
                                      value={formData.manage_emails_title}
                                  />
                              </div>
                          </div>
                          <div className="form-item manage-emails-apply">
                              <button className="form-submit" onClick={handleSubmit} >Apply</button>
                          </div>
                          <div className="manage-emails-clear"></div>
                      </form>
                        <div className="manage_emails-view-content">
                          <table className="manage-emails-view-table">
                                                             <div style={{ width: '100%' }}>
                                                              <DataGrid
                                                              rows={rows}
                                                              columns={columns}
                                                              rowCount={rowCount}
                                                              paginationMode="server"
                                                              sortingMode="server"
                                                              filterMode="server"
                                                              paginationModel={paginationModel}
                                                              onPaginationModelChange={setPaginationModel}
                                                              sortModel={sortModel}
                                                              onSortModelChange={setSortModel}
                                                               filterModel={filterModel}
                                                              onFilterModelChange={setFilterModel}
                                                              pageSizeOptions={[5, 10, 25,50]}
                                                              getRowId={() => crypto.randomUUID()}
                                                              getRowHeight={() => 'auto'}
                                                              disableColumnFilter 
                                                              disableColumnResize={true}
                                                          />
                              </div>
                                                      </table>
                            
                        </div>

                    </div>

                </div>
        </>
        <div class="right">
            <SalespersonSidebar/>
        </div>
        </div>
       )}
    </>  
    );
};

export default ManageEmails;